/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'company-hub.card-extensions.card-config.background-color-field.title': '背景色',
  'company-hub.card-extensions.card-config.text-color-field.title': 'テキストの色',
  'company-hub.card-extensions.large-card.large-card-v1.empty-state.title-placeholder': 'カードにタイトルを付ける',
  'company-hub.card-extensions.large-card.large-card-v2.empty-state.title-placeholder': 'カードにタイトルを付ける',
  'company-hub.card-extensions.medium-card.medium-card-v1.empty-state.title-placeholder': 'カードにタイトルを付ける',
  'company-hub.card-extensions.medium-card.medium-card-v2.empty-state.title-placeholder': 'カードにタイトルを付ける',
  'company-hub.card-extensions.small-card.small-card-v1.empty-state.title-placeholder': 'カードにタイトルを付ける',
  'company-hub.cards-extension.ai-disclaimer.disclaimer-message': 'AI で生成されたコンテンツ',
  'company-hub.cards-extension.autoscroll-wrapper.pause': '一時停止',
  'company-hub.cards-extension.autoscroll-wrapper.play': '再生',
  'company-hub.cards-extension.card-config-panel.content-section.display-options.icon-toggle-label': 'アイコン',
  'company-hub.cards-extension.card-config-panel.content-section.display-options.social-stats-toggle-label':
    'ソーシャルの統計',
  'company-hub.cards-extension.card.background.color': '背景色',
  'company-hub.cards-extension.card.color-contrast.fail':
    '選択したテキストと背景の色は読みやすさの基準を満たしていません。',
  'company-hub.cards-extension.card.color-contrast.success':
    '選択したテキストと背景の色は読みやすさの基準を満たしています。',
  'company-hub.cards-extension.card.text.color': 'テキストの色',
  'company-hub.cards-extension.cards.config-panel.border.color': '枠線の色',
  'company-hub.cards-extension.cards.hub-element.description': 'リンク、画像などを表示',
  'company-hub.cards-extension.cards.hub-element.title': 'カード',
  'company-hub.cards-extension.config-panel.link.field.label': 'リンク',
  'company-hub.cards-extension.config-panel.render-variant.dynamic': '<p>動的</p>',
  'company-hub.cards-extension.config-panel.render-variant.dynamic.description':
    '<strong>動的</strong>カードを使用して、自動更新されるカード セットを即座に生成するフィルターを作成できます。',
  'company-hub.cards-extension.config-panel.render-variant.manual': '<p>手動</p>',
  'company-hub.cards-extension.config-panel.render-variant.manual.description':
    '<strong>手動</strong>カードを使用して、ハブに特定のリンク、テキスト、画像を追加できます。',
  'company-hub.cards-extension.description.field.label': '説明',
  'company-hub.cards-extension.dynamic-card-empty-state.no-filter-title':
    'フィルターを追加してカードにデータを入力してください。',
  'company-hub.cards-extension.dynamic-card-empty-state.no-results-title':
    'まだ何もありません。少ししてからもう一度お確かめください。',
  'company-hub.cards-extension.link-cards-config-panel.cards.content.display-options.title': '表示のオプション',
  'company-hub.cards-extension.link-cards-config-panel.cards.error.invalid-list': 'カードを追加してください',
  'company-hub.cards-extension.link-cards-config-panel.cards.style.general.title': '全般',
  'company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.fixed-image-height.description':
    'カードの画像サイズはすべて同じになります',
  'company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.fixed-image-height.label':
    '画像の高さが固定',
  'company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.flexible-image-height.description':
    '画像サイズはテキストの量に応じて変化します',
  'company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.flexible-image-height.label':
    '画像の高さが可変',
  'company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.title': 'レイアウト',
  'company-hub.cards-extension.link-cards-config-panel.cards.text.description': 'リンク、画像などを表示します。{link}',
  'company-hub.cards-extension.link-cards-config-panel.cards.text.description-without-support-link':
    'リンク、画像などを表示します。',
  'company-hub.cards-extension.link-cards-config-panel.cards.text.description.link':
    'カードに関する詳細をご確認ください。',
  'company-hub.cards-extension.link-cards-config-panel.content-tab.label': 'コンテンツ',
  'company-hub.cards-extension.link-cards-config-panel.size-field.drop-down.item.large.label': '大',
  'company-hub.cards-extension.link-cards-config-panel.size-field.drop-down.item.medium.label': '中',
  'company-hub.cards-extension.link-cards-config-panel.size-field.drop-down.item.small.label': '小',
  'company-hub.cards-extension.link-cards-config-panel.size-text-label': 'サイズ',
  'company-hub.cards-extension.link-cards-config-panel.styles-tab.label': 'スタイル',
  'company-hub.cards-extension.link-cards-config-panel.styles.autoscroll-label': '自動スクロール',
  'company-hub.cards-extension.link-cards-config-panel.styles.autoscroll-tooltip-content':
    '編集モードを終了すると、画面に収まらないカードのスクロールが開始されます',
  'company-hub.cards-extension.link-cards-config-panel.styles.display-as-label': '次の形式で表示',
  'company-hub.cards-extension.link-cards-config-panel.styles.padding-label': 'パディング',
  'company-hub.cards-extension.link-cards-config-panel.styles.row-description': 'カードは 1 行にスクロール表示されます',
  'company-hub.cards-extension.link-cards-config-panel.styles.row-label': '行',
  'company-hub.cards-extension.link-cards-config-panel.styles.stacked-description': 'カードは複数の行に折り返されます',
  'company-hub.cards-extension.link-cards-config-panel.styles.stacked-label': '重ねて表示',
  'company-hub.cards-extension.link-cards-config-panel.title-text-label': 'カード',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.ai-description.label-v2': '説明',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.avatar.label': '所有者を表示',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.avatar.label-v2': 'コンテンツ所有者',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.info-icon-label':
    'カードを表示する Confluence ユーザー グループを選択',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.label.label-v2': 'ラベル',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.new-lozenge-label': 'New',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.new-lozenge-label-v2': 'New',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.publish-date.label': '最終更新日を表示',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.publish-date.label-v2': '最終更新',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.segmentation.label':
    'ターゲット オーディエンスを選択',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.segmentation.label-v2':
    'ターゲット オーディエンス',
  'company-hub.cards-extension.link-cards-content.card-components.build-dynamic-cards': '動的カードの作成',
  'company-hub.cards-extension.link-cards-content.card-components.card-count-label': 'カード数',
  'company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.cancel-button':
    'キャンセル',
  'company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.clear-all-filters-button':
    'すべてのフィルターをクリア',
  'company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.confirm-button': '実行',
  'company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.header':
    '動的カードの作成',
  'company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.header-subtext':
    '最新の情報を表示する自動入力カードのカスタム セットを作成します。フィルターを使用して、ラベル、スペース、所有者などでカードのコンテンツを選択できます。',
  'company-hub.cards-extension.link-cards-content.card-components.error-states.no-dynamic-cards.header':
    '動的カードはまだありません',
  'company-hub.cards-extension.link-cards-content.card-components.error-states.no-results.description':
    'コンテンツが存在しないか、このリンクの追加後に変更された可能性があります',
  'company-hub.cards-extension.link-cards-content.card-components.error-states.no-results.header':
    'このコンテンツを表示できません',
  'company-hub.cards-extension.link-cards-content.card-components.error-states.restricted-content.button.label':
    'アクセス権をリクエスト',
  'company-hub.cards-extension.link-cards-content.card-components.error-states.restricted-content.description':
    'このプレビューを表示するには、アクセス権をリクエストするか別のアカウントを使用する必要があります',
  'company-hub.cards-extension.link-cards-content.card-components.error-states.restricted-content.header':
    '制限付きコンテンツ',
  'company-hub.cards-extension.link-cards-content.card-components.view-current-filters': '現在のフィルターを表示',
  'company-hub.cards-extension.manifest.macro-description': 'リンクをカードとして表示',
  'company-hub.cards-extension.manifest.macro-title': 'カード',
  'company-hub.cards-extension.recommended.field.label': '(推奨)',
  'company-hub.cards-extension.row-orientation.next': '次へ',
  'company-hub.cards-extension.row-orientation.previous': '戻る',
  'company-hub.cards-extension.smart-card.empty-state.placeholder-title': 'タイトルを追加',
  'company-hub.cards-extension.smart-card.no-results-title':
    'ここにはまだ何もありません。少ししてからもう一度お確かめください。',
  'company-hub.cards-extension.title.field.label': 'タイトル',
};
